<div class="btn-group">
    <ng-content></ng-content>
    <button type="button" class="btn btn-sm btn-secondary" (click)="click()">
        <clr-icon shape="resize-up"></clr-icon> {{ expanded ? 'Collapse all' : 'Expand all' }}
    </button>
</div>
